import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Orb from "./Orb";
import { useTranslation } from "react-i18next";

// Hero slide data
const people = [
  {
    key: "people-gun",
    pic: "../assets/images/box-gun.svg",
    colorClass: "color-purple",
  },
  {
    key: "people-sarah",
    pic: "../assets/images/box-sarah.svg",
    colorClass: "color-red",
  },
  {
    key: "people-reza",
    pic: "../assets/images/box-reza.svg",
    colorClass: "color-green",
  },
];

const StoryFeature = () => {
  const { t } = useTranslation();
  return (
    <section className="who-we-are">
      <Container style={{ paddingBottom: "60px" }}>
        <Orb color="rgb(167, 209, 105)" bottom="20vh" right="-40vh" />

        <h2 className="text-center mb-3 section-title color-purple">
          <span id="title-eclipse">{t("who-we-are-title")}</span>
        </h2>
        <div className="d-none d-md-block">
          <Row className="padding-content">
            {people.map((item, index) => {
              const img = (
                <Col key={"img" + item.key} md={6} className="item">
                  <img src={item.pic} alt={t(`${item.key}.name`)} className="img-fluid" style={index % 2 === 1 ? { float: "right" } : {}} />
                </Col>
              );

              const desc = (
                <Col key={"desc" + item.key} md={6} className="item d-flex flex-column justify-content-center align-items-center">
                  <div>
                    <div className={"person-name subsection-title " + item.colorClass}>{t(`${item.key}.name`)}</div>
                    <div className="person-title subsection-title">{t(`${item.key}.title`)}</div>
                    <div>{t(`${item.key}.desc`)}</div>
                  </div>
                </Col>
              );

              return <React.Fragment key={item.key}>{index % 2 === 0 ? [img, desc] : [desc, img]}</React.Fragment>;
            })}
          </Row>
        </div>
        <div className="d-block d-md-none">
          <Row className="padding-content">
            {people.map((item, index) => {
              const img = (
                <Col key={"img" + item.key} xs={12} className="item">
                  <img src={item.pic} alt={item.name} className="person-image img-fluid" />
                </Col>
              );

              const desc = (
                <Col key={"desc" + item.key} xs={12} className="item d-flex flex-column justify-content-center align-items-center">
                  <div>
                    <div className={"person-name subsection-title " + item.colorClass}>{t(`${item.key}.name`)}</div>
                    <div className="person-title subsection-title">{t(`${item.key}.title`)}</div>
                    <div>{t(`${item.key}.desc`)}</div>
                  </div>
                </Col>
              );

              return <React.Fragment key={item.key}>{[img, desc]}</React.Fragment>;
            })}
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default StoryFeature;
